// Cognito pool config for staging. Both staging and prod share the same
// user pool per the auth doc — only the API base URL differs.

export default {
  region: 'us-east-1',
  userPoolId: 'us-east-1_JX3peb0KH',
  clientId: 'po7ngq99htlhtj0q16j6887bu'
};